import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Field, FieldArray, isEmptyArray, useFormikContext } from "formik";
import { get } from "lodash";
import {
  CsplTable as Table,
  FieldInputDollar,
  FieldDropSide,
  SearchableList,
} from "../../../../../../components";
import { usCurrency, getNullTableItem } from "../../../../../../utils";
import { useDeepEffect } from "../../../../../../abstracts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { getForfeitureDetails } from "../../../../../../services";

const FundingDetails = ({
  triggerSlider,
  setTriggerSlider,
  data,
  title,
  columns,
  fieldArrayName,
  show,
  setShow,
  achBankDetails,
  setTotal,
  isBank = false,
  isForfeiture = false,
  isAch = false,
  errors = false,
  payrollBankDetails,
  transDetailByPlan,
}) => {
  const { values, setFieldValue, handleChange } = useFormikContext();
  //cumulative amount
  useDeepEffect(() => {
    let bankFund = show.bank
      ? values.bankFundings.map((_) => (_.bankFund !== "" ? _.bankFund : 0))
      : [0];
    let forfeitureFund = show.forfeiture
      ? values.forfeitureFundings.map((_) =>
          _.forfeitureFund !== "" ? _.forfeitureFund : 0
        )
      : [0];
    let achFund = show.ach
      ? [
          get(values, "achDebitFundings[0].amount", 0) !== ""
            ? get(values, "achDebitFundings[0].amount", 0)
            : 0,
        ]
      : [0];
    let amt = bankFund.concat(forfeitureFund, achFund);
    var sum = amt.reduce((accumulator, currentValue) => {
      return (accumulator ?? 0) + (currentValue ?? 0);
    }, 0);
    setTotal(sum);
  }, [values]);
  let tempData = [];
  if (isForfeiture) {
    tempData = data.map((item) => {
      const totalBalance =
        transDetailByPlan &&
        transDetailByPlan[0]?.transactionSourceDetails.find(
          (itm) => item.sourceId == itm.sourceId
        );
      return (item = {
        ...item,
        amountInFile: totalBalance?.amount,
      });
    });
  } else {
    tempData = data;
  }
  return (
    <div className="mb-4">
      <div className="ft-16 font-weight-500 mb-3">
        <Row>
          <Col md={2} lg={3}>
            <span className="mr-2">{title}</span>
          </Col>
          <Col md={10} lg={9}>
            <Form.Check
              type="switch"
              id={`custom-switch-${title}`}
              label=" "
              onChange={() => {
                if (isBank) {
                  setFieldValue(
                    "bankFundings",
                    data.map((i) => {
                      return (i = {
                        bankId: i.id,
                        bankName: i.bankName,
                        bankBalance: i.accountBalance,
                        bankFund: i.amount,
                      });
                    })
                  );
                  setShow({ ...show, bank: !show.bank });
                } else if (isForfeiture) {
                  setFieldValue(
                    "forfeitureFundings",
                    tempData.map((i) => {
                      return (i = {
                        amountInFile: i.amountInFile,
                        forfeitureId: i.id,
                        forfeitureBalance: i.forfeitureBalance,
                        forfeitureFund: i.amount,
                      });
                    })
                  );
                  setShow({ ...show, forfeiture: !show.forfeiture });
                } else {
                  // setFieldValue(
                  //   "achDebitFundings",
                  //   data.map((i) => {
                  //     return (i = {
                  //       bankId: i.bankId ,
                  //       bankName: i.bankName,
                  //       amount: triggerSlider === false ? null : get(values, "achDebitFundings[0].amount")
                  //     });
                  //   })
                  // );
                  setFieldValue(
                    "achDebitFundings[0].bankName",
                    triggerSlider === false
                      ? null
                      : get(values, "achDebitFundings[0].bankName")
                  );
                  setFieldValue(
                    "achDebitFundings[0].amount",
                    triggerSlider === false
                      ? null
                      : get(values, "achDebitFundings[0].amount")
                  );
                  // setFieldValue(
                  //   "achDebitFundings[0].bankId",
                  //   triggerSlider === false
                  //     ? null
                  //     : get(values, "achDebitFundings[0].bankId")
                  // );
                  setShow({ ...show, ach: !show.ach });
                }
              }}
              checked={
                isBank ? show.bank : isForfeiture ? show.forfeiture : show.ach
              }
              value={
                isBank ? show.bank : isForfeiture ? show.forfeiture : show.ach
              }
            />
          </Col>
        </Row>
      </div>

      {(isBank && show.bank) ||
      (isForfeiture && show.forfeiture) ||
      (isAch && show.ach) ? (
        <FieldArray name={fieldArrayName}>
          {() => {
            return (
              <>
                <Table className="error-report-table">
                  <Table.Thead>
                    <Table.Tr>
                      {columns.map((item, index) => {
                        return (
                          <Table.Th key={index} className={item.className}>
                            {item.label}
                          </Table.Th>
                        );
                      })}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {/* {isForfeiture
                      ? transDetailByPlan.map((data, cellInd) => {
                          return (
                            <Table.Tr>
                              <Table.Td>{data?.sourceName}</Table.Td>
                              <Table.Td>{data?.amount}</Table.Td>
                            </Table.Tr>
                          );
                        }) */}
                    {tempData &&
                      tempData.map((payrollItem, index) => {
                        // const a = transDetailByPlan[0].transactionSourceDetails.map(
                        //   (data) => {
                        //     return data;
                        //   }
                        // );
                        return (
                          <Table.Tr key={index}>
                            {columns.map((item, cellIndex) => {
                              const getContent = () => {
                                const fieldName = `${fieldArrayName}[${index}].${item.columnName}`;
                                const bankFund = get(
                                  values,
                                  `${fieldArrayName}[${index}].bankFund`,
                                  0
                                );

                                if (
                                  item.columnName === "bankFund" ||
                                  item.columnName === "amount"
                                ) {
                                  return (
                                    <div className="display-block">
                                      <Field
                                        name={fieldName}
                                        isRequired
                                        autoComplete="off"
                                        preventNegative
                                        type="number"
                                        value={get(values, fieldName)}
                                        min={0}
                                        max={9999999.99}
                                        onChange={handleChange}
                                        component={FieldInputDollar}
                                        disabled={
                                          triggerSlider &&
                                          fieldArrayName != "achDebitFundings"
                                        }
                                      />
                                    </div>
                                  );
                                }

                                if (item.columnName === "sourceName") {
                                  return payrollItem.sourceName;
                                }

                                if (item.columnName === "amountFile") {
                                  return usCurrency(payrollItem.amountInFile);
                                }

                                if (item.columnName === "forfeitureFund") {
                                  return (
                                    <div className="display-block">
                                      <Field
                                        size="sm"
                                        name={fieldName}
                                        isRequired
                                        autoComplete="off"
                                        preventNegative
                                        type="number"
                                        value={get(values, fieldName)}
                                        min={0}
                                        max={
                                          payrollItem.amountInFile <
                                          payrollItem.forfeitureBalance
                                            ? payrollItem.amountInFile
                                            : payrollItem.forfeitureBalance
                                        }
                                        onChange={handleChange}
                                        component={FieldInputDollar}
                                      />
                                    </div>
                                  );
                                }

                                if (item.columnName === "bankId") {
                                  return (
                                    <div className="display-block">
                                      <Field
                                        size="smd"
                                        isRequired
                                        name={fieldName}
                                        value={get(values, fieldName)}
                                        options={achBankDetails.map(
                                          (bank, index) => ({
                                            label: bank.bankName,
                                            value: parseInt(bank.id),
                                          })
                                        )}
                                        popupContent={
                                          <SearchableList
                                            label="Select bank"
                                            isRadio
                                            isNotTypeAhead
                                            selectedValue={values[fieldName]}
                                            options={achBankDetails.map(
                                              (bank, index) => ({
                                                label: bank.bankName,
                                                value: parseInt(bank.id),
                                              })
                                            )}
                                            onSelect={(value, label) => {
                                              setFieldValue(fieldName, value);
                                              setFieldValue(
                                                `${fieldArrayName}[${index}].bankName`,
                                                label
                                              );
                                            }}
                                          />
                                        }
                                        direction="bottom"
                                        component={FieldDropSide}
                                      />
                                    </div>
                                  );
                                }

                                if (item.columnName === "planAccountId") {
                                  return (
                                    <div className="display-block">
                                      <Field
                                        size="smd"
                                        isRequired
                                        name={fieldName}
                                        value={get(values, fieldName)}
                                        options={payrollBankDetails.map(
                                          (bank, index) => ({
                                            label: bank.bankName,
                                            value: parseInt(bank.id),
                                          })
                                        )}
                                        popupContent={
                                          <SearchableList
                                            label="Select Plan Account"
                                            isRadio
                                            isNotTypeAhead
                                            selectedValue={values[fieldName]}
                                            options={payrollBankDetails.map(
                                              (bank, index) => ({
                                                label: bank.bankName,
                                                value: parseInt(bank.id),
                                              })
                                            )}
                                            onSelect={(value, label) => {
                                              setFieldValue(fieldName, value);
                                              setFieldValue(
                                                `${fieldArrayName}[${index}].planAccountName`,
                                                label
                                              );
                                            }}
                                          />
                                        }
                                        direction="bottom"
                                        component={FieldDropSide}
                                      />
                                    </div>
                                  );
                                }

                                if (item.columnName === "accountBalance") {
                                  return usCurrency(
                                    payrollItem[item.columnName] - bankFund
                                  );
                                }

                                if (item.columnName === "forfeitureBalance") {
                                  return usCurrency(
                                    payrollItem[item.columnName]
                                  );
                                }
                                return payrollItem[item.columnName];
                              };
                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  {getNullTableItem(getContent())}
                                </Table.Td>
                              );
                            })}
                          </Table.Tr>
                        );
                      })}
                  </Table.Tbody>
                </Table>
                {errors && (
                  <span className="d-flex justify-content-end ft-14 error-text mb-1">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="#f16973"
                      className="mt-1 mr-1"
                    />
                    {errors}
                  </span>
                )}
              </>
            );
          }}
        </FieldArray>
      ) : null}
    </div>
  );
};

export default FundingDetails;
